<template>
  <div>
    <b-form @submit="onSubmit">
      <div class="contents course-edit">
        <div class="row border-top-dgray border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">
              {{ $t("title.common.course") }}
            </label>
          </div>
          <div class="col-md-9">
            <input type="text" v-model="form.coursename" required />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{ $t("title.common.code") }}</label>
          </div>
          <div class="col-md-9">
            <input
              type="text"
              v-model="form.coursecode"
              required
              maxlength="6"
              :placeholder="$t('text.golfcourse.golfcourse_code_placeholder')"
            />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{ $t("title.common.hole") }}</label>
          </div>
          <div class="col-md-9">
            <input
              type="text"
              required
              placeholder="18"
              v-model="form.holesum"
            />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.golfcourse.par_count")
            }}</label>
          </div>
          <div class="col-md-9">
            <input
              type="text"
              required
              placeholder="72"
              v-model="form.parsum"
            />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.golfcourse.subcourse_count")
            }}</label>
          </div>
          <div class="col-md-9">
            <select
              class="form-select-lg"
              v-model="form.subcourselistcnt"
              @change="input_subcoursecnt($event)"
            >
              <template v-for="(bnt, index) in subcoursecnt">
                <option :value="bnt" :key="index + 'r'">{{ bnt }}</option>
              </template>
            </select>
          </div>
        </div>

        <div v-for="(anc, index) in subcoursecnt" :key="index">
          <div
            class="row border-bottom"
            v-if="index < form.subcourselistcnt"
          >
            <div class="col-md bg-gray row align-items-center">
              <label class="d-table-cell"
                >{{ $t("title.golfcourse.sub_course") }} {{ anc }}</label
              >
            </div>
            <div class="col-md-9">
              <input
                type="text"
                required
                v-model="form.subcourse.subcoursename[index]"
                class="mb-3"
              />

              <b-table-simple small bordered responsive table-class="hole-info">
                <b-tbody>
                  <b-tr>
                    <b-th sticky-column class="border-end">{{ $t("title.common.hole") }}</b-th>
                    <b-td
                      v-for="(bnc, index2) in form.subcourse.subcoursehole[
                        index
                      ].hole"
                      :key="index2"
                      @click="showModal()" 
                    >
                      {{ bnc }}
                    </b-td>
                    <b-td>
                      {{ $t("title.golfcourse.sum") }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th sticky-column class="border-end">{{ $t("title.common.par") }}</b-th>
                    <b-td
                      v-for="(cnc, index3) in form.subcourse.subcoursehole[
                        index
                      ].par"
                      :key="index3"
                    >
                      <input
                        type="text"
                        v-model="
                          form.subcourse.subcoursehole[index].par[index3]
                        "
                        required
                      />
                    </b-td>
                    <b-td>
                      <input
                        type="text"
                        v-model="form.subcourse.subcourseparsum[index]"
                        required
                      />                      
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th sticky-column class="border-end">{{ $t("title.common.handicap") }}</b-th>
                    <b-td
                      v-for="(cnc, index4) in form.subcourse.subcoursehole[
                        index
                      ].handicap"
                      :key="index4"
                    >
                      <input
                        type="text"
                        v-model="
                          form.subcourse.subcoursehole[index].handicap[index4]
                        "
                        required
                      />
                    </b-td>
                    <b-td>
                      <input type="text" value="-" />
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>              
            </div>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.golfcourse.course_image")
            }}</label>
          </div>
          <div class="col-md-9">
            <div class="input-group">
              <input
                type="text"
                class="form-control text-truncate"
                :value="filename_"
                :placeholder="$t('text.common.no_file_chosen')"
              />
              <button
                type="button"
                class="btn btn-primary btn-lg icon-attachment"
                @click="$refs.file.click()"
              >
                {{ $t("button.common.choose_file") }}
                <input
                  type="file"
                  ref="file"
                  @change="fileSelect()"
                  class="d-none"
                />
              </button>
            </div>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell"
              >{{ $t("title.golfcourse.course_use") }}
            </label>
          </div>
          <div class="col-md-9">
            <div class="d-flex flex-column flex-md-row my-2">
              <div class="my-1 pe-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="flexCheck1"
                    v-model="form.status"
                    true-value="0"
                    false-value="1"
                  />
                  <label class="form-check-label" for="flexCheck1">
                    {{ $t("text.common.use") }}
                  </label>
                </div>
              </div>
              <div class="my-1 pe-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="flexCheck2"
                    v-model="form.viewflag"
                    true-value="1"
                    false-value="0"
                  />
                  <label class="form-check-label" for="flexCheck2">
                    {{ $t("text.golfcourse.check_view_hole") }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">
              {{ $t("title.golfcourse.difficulty") }}
            </label>
          </div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-6 mb-2 mb-md-0 pe-md-1">
                <select class="form-select-lg" v-model="form.field" required>
                  <option value="">
                    {{ $t("filter.golfcourse.course") }}
                  </option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>

              <div class="col-md-6 ps-md-1">
                <select class="form-select-lg" v-model="form.green" required>
                  <option value="">
                    {{ $t("filter.golfcourse.green") }}
                  </option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell"
              >{{ $t("title.golfcourse.city") }}/{{
                $t("title.golfcourse.state")
              }}</label
            >
          </div>
          <div class="col-md-9">
            <input type="text" v-model="form.area" required />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.golfcourse.country")
            }}</label>
          </div>
          <div class="col-md-9">
            <select class="form-select-lg" v-model="form.country" required>
              <option
                v-for="(country, index) in countrylist"
                :key="index + 'c'"
                :value="country.countryno"
              >
                {{ country.countryname }}
              </option>
            </select>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.common.description")
            }}</label>
          </div>
          <div class="col-md-9">
            <textarea
              v-model="form.contents"
              cols="30"
              rows="10"
              :placeholder="$t('title.common.description')"
              required
            ></textarea>
          </div>
        </div>

        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            :aria-label="$t('button.common.list')"
            @click="$router.push({ name: 'CourseList' })"
            >{{ $t("button.common.list") }}</b-button
          >
          <b-button
            size="xl"
            variant="primary"
            :aria-label="$t('button.common.save')"
            type="submit"
            >{{ $t("button.common.save") }}</b-button
          >
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import ax from "@/api/course";
import ax2 from "@/api/member";
import i18n from "@/i18n";
export default {
  name: "CourseWrite",
  data() {
    return {
      form: {
        coursename: "",
        coursecode: "",
        holesum: "",
        parsum: "",
        subcourselistcnt: "2",
        subcourse: {
          subcoursename: [],
          subcourseparsum: [],
          subcoursehole: [
            {
              hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
              par: [0, 0, 0, 0, 0, 0, 0, 0, 0],
              handicap: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
              hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
              par: [0, 0, 0, 0, 0, 0, 0, 0, 0],
              handicap: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
              hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
              par: [0, 0, 0, 0, 0, 0, 0, 0, 0],
              handicap: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
              hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
              par: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        filename: "",
        status: "0",
        viewflag: "",
        field: "",
        green: "",
        country: "",
        area: "",
        contents: "",
      },
      filename_: "",
      subcoursecnt: [1, 2, 3, 4],
      countrylist: [],
    };
    // return {
    //   form: {
    //     coursename: 'test course2111',
    //     coursecode: 'C_2111',
    //     holesum: '18',
    //     parsum: '72',
    //     subcourselistcnt: '1' ,
    //     subcourse:
    //     {
    //       subcoursename: ['out','in'],
    //       subcourseparsum: [36,36],
    //       subcoursehole: [
    //       {
    //         hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    //         par: [4, 4, 4, 4, 4, 4, 4, 4, 4]
    //       },
    //       {
    //         hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    //         par: [4, 4, 4, 3, 4, 5, 4, 3, 5]
    //       },
    //       {
    //         hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    //         par: [0, 0, 0, 0, 0, 0, 0, 0, 0]
    //       },
    //       {
    //         hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    //         par: [0, 0, 0, 0, 0, 0, 0, 0, 0]
    //       }
    //       ]
    //     },
    //     filename: '',
    //     status: '0',
    //     viewflag: '0',
    //     field: '2',
    //     green: '2',
    //     country: '2',
    //     area: 'LKA',
    //     contents: 'contents test'
    //   },
    //   subcoursecnt:  [
    //       1, 2, 3, 4
    //   ],
    //   countrylist: []
    // }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();

      if (!this.check_coursecode(this.form.coursecode)) {
        alert(this.$i18n.t("alert.golfcourse.Invalid_course_code"));
        return false;
      }

      let formData = new FormData();
      formData.append("coursename", this.form.coursename);
      formData.append("coursecode", this.form.coursecode);
      formData.append("holesum", this.form.holesum);
      formData.append("parsum", this.form.parsum);
      formData.append("subcourselistcnt", this.form.subcourselistcnt);

      //alert(this.form.subcourse.subcoursehole[0])
      for (let i = 0; i < this.form.subcourselistcnt; i++) {
        formData.append(
          "subcoursename[" + i + "]",
          this.form.subcourse.subcoursename[i]
        );
        formData.append(
          "subcourseparsum[" + i + "]",
          this.form.subcourse.subcourseparsum[i]
        );

        for (let j = 0; j < 9; j++) {
          formData.append(
            "hole[" + i + "][" + j + "]",
            this.form.subcourse.subcoursehole[i].hole[j]
          );
          formData.append(
            "par[" + i + "][" + j + "]",
            this.form.subcourse.subcoursehole[i].par[j]
          );
          formData.append(
            "handicap[" + i + "][" + j + "]",
            this.form.subcourse.subcoursehole[i].handicap[j]
          );
        }
      }

      formData.append("filename", this.form.filename);
      // this.form.status = this.form.status ? 1 : 0
      formData.append("status", this.form.status);
      // this.form.viewflag = this.form.viewflag ? 1 : 0
      formData.append("viewflag", this.form.viewflag);
      formData.append("field", this.form.field);
      formData.append("green", this.form.green);
      formData.append("country", this.form.country);
      formData.append("area", this.form.area);
      formData.append("contents", this.form.contents);

      formData.entries();
      const _this = this;
      ax.set_admincoursewrite(formData, function (flag, data) {
        alert(data.message);
        if (flag) {
          _this.$router.push({ name: "CourseList" });
        }
      });
    },
    showModal(hole, type) {
      alert(this.$i18n.t("alert.golfcourse.after_register_course"));
      return false;
    },
    input_subcoursecnt(event) {
      this.subcourselistcnt = event.target.value;
    },
    fileSelect() {
      this.filename_ = this.$refs.file.files[0].name;
      this.form.filename = this.$refs.file.files[0];
    },
    check_coursecode(code) {
      let re = /([C,D]_\d{4})/;
      return re.test(code);
    },
    get_countrylist() {
      ax2.get_countrylist((flag, data) => {
        if (flag) {
          this.countrylist = data.countrylist;
        } else {
          alert(data);
        }
      });
    },
  },
  mounted() {
    this.get_countrylist();
  },
};
</script>